"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectGroup = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const dropdown_custom_1 = require("../dropdown-custom");
/**
 * Compoused input for 2 dropdown, the second dropdown (slave)
 * depends of first dropdown (master) data
 * @param props
 */
const SelectGroup = props => {
    const { dropdownOption, masterSelect, slaveSelect, formikProps } = props;
    const { setFieldValue, setFieldTouched, values, errors, touched, setValues } = formikProps;
    const [slaveSelectOptions, setSlaveSelectOptions] = (0, react_1.useState)([]);
    const masterSelectOptions = Object.keys(dropdownOption);
    /**
     * Change master dropdown and slave according to master options
     * @param value
     */
    const onHandleMasterChange = (option, touch) => {
        const value = option.value || '';
        setValues(Object.assign(Object.assign({}, values), { [masterSelect.name]: value, [slaveSelect.name]: dropdownOption[value][0] }));
        setSlaveSelectOptions(dropdownOption[value]);
        touch && setFieldTouched(masterSelect.name, true, false);
    };
    /**
     * Change Slave dropdown
     * @param optionValue
     */
    const onHandleSlaveChange = (optionValue, touch) => {
        let value = optionValue.value;
        if (!optionValue)
            value = '';
        setFieldValue(slaveSelect.name, value, false);
        touch && setFieldTouched(slaveSelect.name, true, false);
    };
    /**
     * Get master options to render
     */
    const getMasterOptions = () => {
        if (masterSelectOptions.length) {
            return masterSelectOptions.map((masterOption) => (react_1.default.createElement('div', {
                value: masterOption,
                label: masterOption
            }, masterOption)));
        }
        return [react_1.default.createElement(react_1.default.Fragment, null)];
    };
    /**
     * Get slave options to render
     */
    const getSlaveOptions = () => {
        {
            if (slaveSelectOptions && slaveSelectOptions.length) {
                return slaveSelectOptions.map((slaveOption) => (react_1.default.createElement('div', {
                    value: slaveOption,
                    label: slaveOption
                }, slaveOption)));
            }
            return [react_1.default.createElement(react_1.default.Fragment, null)];
        }
    };
    return (react_1.default.createElement(styled_1.StyledSelectGroup, { className: "dropdown-group" },
        react_1.default.createElement(styled_1.StyledMasterWrapper, { className: "master-dropdown" },
            react_1.default.createElement(dropdown_custom_1.DropdownCustom, { name: masterSelect.name, label: masterSelect.label, value: { value: values[masterSelect.name], label: values[masterSelect.name] }, placeholder: masterSelect.placeholder, onChange: onHandleMasterChange, appearance: errors[masterSelect.name] && touched[masterSelect.name]
                    ? 'error'
                    : 'default', errorText: errors[masterSelect.name], onTouch: setFieldTouched.bind(null, masterSelect.name, true, true) }, getMasterOptions())),
        react_1.default.createElement(dropdown_custom_1.DropdownCustom, { name: slaveSelect.name, label: slaveSelect.label, onChange: onHandleSlaveChange, value: { value: values[slaveSelect.name], label: values[slaveSelect.name] }, placeholder: slaveSelect.placeholder, appearance: errors[slaveSelect.name] && touched[slaveSelect.name]
                ? 'error'
                : 'default', onTouch: setFieldTouched.bind(null, slaveSelect.name, true), errorText: errors[slaveSelect.name] }, getSlaveOptions())));
};
exports.SelectGroup = SelectGroup;
